import { useEffect, useState } from "react";
import CommonEdit from "@/components/common/Edit";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";
import { Location } from "@/interface/dataInterface";
import OrderFormTaxiCommon from "@/components/common/OrderFormTaxi";
import axiosInstance from "@/utils/axiosInstance";
import { OrderForm } from "@/interface/formInterface";
import { Orders } from "@/interface/entityInterface";

const OrderEdit = ({ id }: { id: number }) => {
  const [data, setData] = useState<Orders | null>(null);

  const [formProp, setFormProp] = useState<OrderForm>({
    fullName: "",
    client_phone: "",
    date: "",
    time: "",
    fare: "",
    currency: "",
    email: "",
    notes: "",
    status: "",
  });
  const [location, setLocation] = useState<Location>({
    text: "",
    lat: 0,
    lng: 0,
  });
  const [dropoff, setDropoff] = useState<Location>({
    text: "",
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    const unsub = async () => {
      const response = await axiosInstance.get<Orders>(`/taxi-orders/${id}`);
      const seperateDate = seperateDateAndTime(response.data.pickup_time);
      setData(response.data);
      const {
        client_name,
        fare,
        currency,
        client_phone,
        email,
        notes,
        status,
        pickup,
        pickup_latitude,
        pickup_longitude,
        dropoff,
        dropoff_latitude,
        dropoff_longitude,
      } = response.data;
      setFormProp({
        fullName: client_name,
        client_phone,
        fare: fare || "",
        currency,
        email: email || "",
        date: seperateDate.datePart,
        time: seperateDate.timePart,
        notes: notes,
        status: status,
      });
      setLocation({
        text: pickup,
        lat: pickup_latitude,
        lng: pickup_longitude,
      });
      setDropoff({
        text: dropoff,
        lat: dropoff_latitude,
        lng: dropoff_longitude,
      });
    };
    unsub();
  }, [id]);

  return (
    <CommonEdit
      title="Edit"
      description={`Edit order with id ${id}`}
      id={id}
      resource="taxi-orders"
      data={{
        ...data,
        fare: formProp.fare || 0,
        currency: formProp.currency,
        email: formProp.email,
        pickup_time: mergeDateAndTime(formProp.date, formProp.time),
        client_name: formProp.fullName,
        client_phone: formProp.client_phone,
        notes: formProp.notes,
        status: formProp.status,
        pickup: location.text,
        pickup_latitude: location.lat,
        pickup_longitude: location.lng,
        dropoff: dropoff.text,
        dropoff_latitude: dropoff.lat,
        dropoff_longitude: dropoff.lng
      }}
    >
      <OrderFormTaxiCommon
        formProp={formProp}
        setFormProp={setFormProp}
        location={location}
        setLocation={setLocation}
        dropoff={dropoff}
        setDropoff={setDropoff}
      />
    </CommonEdit>
  );
};

export default OrderEdit;
